import {
  cibAndroid,
  cibApple,
  cibAppStoreIos,
  cibWindows,
  cilApps,
  cilBarChart,
  cilBellExclamation,
  cilChartLine,
  cilCheck,
  cilChevronCircleDownAlt,
  cilChevronCircleUpAlt,
  cilClipboard,
  cilCloudDownload,
  cilCloudUpload,
  cilDevices,
  cilEducation,
  cilEnvelopeLetter,
  cilFindInPage,
  cilGroup,
  cilHeadphones,
  cilHttps,
  cilLan,
  cilLibrary,
  cilLockLocked,
  cilMenu,
  cilMonitor,
  cilNewspaper,
  cilNotes,
  cilOptions,
  cilPeople,
  cilPlus,
  cilReload,
  cilShieldAlt,
  cilSitemap,
  cilSpeedometer,
  cilTransfer,
  cilTrash,
  cilUser,
  cilInfo,
  cilSpreadsheet,
  cilLowVision,
  cilAt,
  cilFilterX,
  cilArrowRight,
  cilCopy,
  cilCheckAlt
} from '@coreui/icons';

export const iconSubset = {
  cibWindows,
  cibApple,
  cilApps,
  cibAppStoreIos,
  cibAndroid,
  cilBarChart,
  cilChartLine,
  cilBellExclamation,
  cilCloudDownload,
  cilChevronCircleDownAlt,
  cilChevronCircleUpAlt,
  cilDevices,
  cilHttps,
  cilHeadphones,
  cilEducation,
  cilEnvelopeLetter,
  cilFindInPage,
  cilLan,
  cilLibrary,
  cilMenu,
  cilMonitor,
  cilNotes,
  cilNewspaper,
  cilOptions,
  cilPeople,
  cilPlus,
  cilReload,
  cilSitemap,
  cilSpeedometer,
  cilTransfer,
  cilTrash,
  cilUser,
  cilCloudUpload,
  cilShieldAlt,
  cilLockLocked,
  cilClipboard,
  cilCheck,
  cilInfo,
  cilSpreadsheet,
  cilGroup,
  cilLowVision,
  cilAt,
  cilFilterX,
  cilArrowRight,
  cilCopy,
  cilCheckAlt
};

export enum IconSubset {
  cibApple = 'cibApple',
  cilApps = 'cilApps',
  cibAppStoreIos = 'cibAppStoreIos',
  cibWindows = 'cibWindows',
  cibAndroid = 'cibAndroid',
  cilBellExclamation = 'cilBellExclamation',
  cilBarChart = 'cilBarChart',
  cilChart = 'cilChart',
  cilCloudDownload = 'cilCloudDownload',
  cilDevices = 'cilDevices',
  cilHttps = 'cilHttps',
  cilHeadphones = 'cilHeadphones',
  cilEducation = 'cilEducation',
  cilEnvelopeLetter = 'cilEnvelopeLetter',
  cilFindInPage = 'cilFindInPage',
  cilLan = 'cilLan',
  cilLibrary = 'cilLibrary',
  cilList = 'cilList',
  cilMenu = 'cilMenu',
  cilMonitor = 'cilMonitor',
  cilMoon = 'cilMoon',
  cilNotes = 'cilNotes',
  cilNewspaper = 'cilNewspaper',
  cilOptions = 'cilOptions',
  cilPen = 'cilPen',
  cilPeople = 'cilPeople',
  cilPlus = 'cilPlus',
  cilReload = 'cilReload',
  cilSitemap = 'cilSitemap',
  cilSpeedometer = 'cilSpeedometer',
  cilTransfer = 'cilTransfer',
  cilTrash = 'cilTrash',
  cilUser = 'cilUser',
  cilCloudUpload = 'cilCloudUpload',
  cilShieldAlt = 'cilShield',
  cilLockLocked = 'cilLockLocked',
  cilClipboard = 'cilClipboard',
  cilCheck = 'cilCheck',
  cilChartLine = 'cilChartLine',
  cilInfo = 'cilInfo',
  cilGroup = 'cilGroup',
  cilLowVision = 'cilLowVision',
  cilAt = 'cilAt',
  cilFilterX = 'cilFilterX',
  cilArrowRight = 'cilArrowRight',
  cilCopy = 'cilCopy',
  cilCheckAlt = 'cilCheckAlt'
}
